"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const router_1 = require("next/router");
const react_1 = require("react");
const components_common_cross_tab_1 = require("@hotelplan/components.common.cross-tab");
const libs_context_page_type_1 = require("@hotelplan/libs.context.page-type");
const libs_context_req_ctx_1 = require("@hotelplan/libs.context.req-ctx");
const auth_constants_1 = require("./auth.constants");
const useCrossTabLogoutHandler = ({ logoutCallback, }) => {
    const pageType = (0, libs_context_page_type_1.usePageType)();
    const { query, asPath, replace, pathname } = (0, router_1.useRouter)();
    const isLogoutState = auth_constants_1.AUTH_LOGOUT_PARAM_NAME in query;
    const [, updateReqContext] = (0, libs_context_req_ctx_1.useReqContextContext)();
    const { broadcast, setHandler } = (0, components_common_cross_tab_1.useCrossTabBroadcast)(auth_constants_1.AUTH_CROSS_TAB_BROADCAST_CHANNEL_KEY);
    (0, react_1.useEffect)(() => {
        if (isLogoutState) {
            broadcast({ logout: true });
            const pathWithoutQueries = asPath.split('?')[0];
            replace(pathname, pathWithoutQueries, {
                scroll: false,
                shallow: true,
            });
        }
    }, [isLogoutState, pathname, asPath, replace, broadcast]);
    (0, react_1.useEffect)(() => {
        setHandler(({ logout }) => __awaiter(void 0, void 0, void 0, function* () {
            if (logout) {
                // used to log out user in another tabs
                updateReqContext({ b2bMarkup: undefined });
                if (typeof logoutCallback === 'function') {
                    logoutCallback(pageType);
                }
            }
        }));
    }, [setHandler, updateReqContext, logoutCallback, pageType]);
};
exports.default = useCrossTabLogoutHandler;
//# sourceMappingURL=useCrossTabLogoutHandler.js.map